import { required } from 'vuelidate/lib/validators'

const formData = {
  accountType: {
    size: 8,
    type: 'select',
    name: 'accountType',
    label: 'Tipo de conta',
    placeholder: 'Escolha uma opção',
    required: true,
    value: '',
    options: [
      {
        name: 'corrente',
        id: 'CORRENTE'
      },
      {
        name: 'poupança',
        id: 'POUPANCA'
      }
    ]
  },
  isActive: {
    size: 4,
    type: 'switch',
    name: 'isActive',
    label: 'Conta Ativa?',
    required: true,
    value: false
  },
  bank: {
    size: 12,
    type: 'autocomplete',
    name: 'bank',
    label: 'Banco',
    placeholder: 'Selecione o seu banco',
    required: true,
    value: '',
    options: []
  },
  agency: {
    size: 5,
    type: 'text',
    name: 'agency',
    label: 'Agência',
    mask: '####',
    placeholder: 'Número da agência',
    value: null
  },
  agencyDigit: {
    size: 4,
    type: 'text',
    name: 'agencyDigit',
    label: 'Dígito',
    mask: '#',
    placeholder: 'Dígito',
    value: null
  },
  accountNumber: {
    size: 5,
    type: 'text',
    name: 'accountNumber',
    label: 'Conta',
    mask: '##########',
    placeholder: 'Número da Conta',
    value: null
  },
  accountDigit: {
    size: 4,
    type: 'text',
    name: 'accountDigit',
    label: 'Dígito',
    mask: '#',
    placeholder: 'Dígito',
    value: null
  },
  'accountName': {
    size: 12,
    type: 'text',
    name: 'accountName',
    label: 'Nome da conta',
    placeholder: 'Identifique esta conta',
    value: null
  }
}

const requiredFields = [
  'agency',
  'accountNumber',
  'accountType',
  'accountName',
  'bank'
]
const validations = {}
for (let requiredField of requiredFields) {
  validations[requiredField] = {}
  validations[requiredField].value = {}
  validations[requiredField].value.required = required
}

export {formData, validations}
